import { render } from "./tinyMCE.vue?vue&type=template&id=792ffbe3"
import script from "./tinyMCE.vue?vue&type=script&lang=js"
export * from "./tinyMCE.vue?vue&type=script&lang=js"

import "./tinyMCE.vue?vue&type=style&index=0&id=792ffbe3&lang=less"
script.render = render

export default script